import doctorImageSrc from "@/assets/qim.png";
import styles from "./ChatBubble.module.scss";

export default function ChatBubble({ children }: React.PropsWithChildren) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <img src={doctorImageSrc} alt="Qim Malmqvist" />
        <span>Qim Malmqvist</span>
      </div>
      <div className={styles.bubble}>{children}</div>
    </div>
  );
}
